// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"76ee7f72","251":"bc850c62","348":"246b732f","364":"6967d7ed","571":"c016af73"}[chunkId] + ".chunk.js";
};